// Classe CSS por verbo HTTP. PATCH divide a cor com PUT, e DELETE usa "m-del"
// (não "m-delete") — mapear na mão evita derivar a classe do nome do método e
// gerar seletores que não existem no styles.css.
const METHOD_CLASS: Record<string, string> = {
  GET: "m-get",
  POST: "m-post",
  PUT: "m-put",
  PATCH: "m-put",
  DELETE: "m-del",
};

export const methodClass = (method: string): string => METHOD_CLASS[String(method).toUpperCase()] ?? "";
